import { ResponsiveModal, ResponsiveModalClose, ResponsiveModalContent, ResponsiveModalTitle } from '@ordering/components/ui/responsive-modal';
import { useFocusRef } from '@ordering/hooks/useFocusRef/useFocusRef';
import type { CollectionPoint } from '@ordering/types/Order';
import { useTranslations } from 'next-intl';
type Props = {
  isOpen?: boolean;
  selectCollectionPointId: (collectionPointId: string) => void;
  handleClose?: () => void;
  collectionPoints: CollectionPoint[];
};
const SelectCollectionPointModal: React.FC<Props> = ({
  isOpen = false,
  handleClose,
  collectionPoints,
  selectCollectionPointId
}) => {
  const t = useTranslations();
  const buttonFocusRef = useFocusRef();
  const handleSelectCollectionPoint = (collectionPointId: string) => {
    selectCollectionPointId(collectionPointId);
    handleClose?.();
  };
  const groupedCollectionPoints = collectionPoints.sort((a, b) => a.name.localeCompare(b.name, undefined, {
    numeric: true
  })).reduce((acc: Record<string, CollectionPoint[]>, collectionPoint: CollectionPoint) => {
    const type = collectionPoint.type;
    (acc[type] ??= []).push(collectionPoint);
    return acc;
  }, {} as Record<string, CollectionPoint[]>);
  const serviceTypes: Record<string, string> = {
    PICKUP: t('order_type_page.service_type.pickup'),
    TABLE: t('order_type_page.service_type.table'),
    COUNTER: t('order_type_page.service_type.counter')
  };
  const handleOnDrawerChange = (isOpen_0: boolean) => {
    if (!isOpen_0) {
      handleClose?.();
    }
  };
  return <ResponsiveModal open={isOpen} onOpenChange={handleOnDrawerChange} dismissible={false}>
      <ResponsiveModalContent displayHandle={false}>
        <div className="w-11/12 mx-auto overflow-y-auto">
          <div className="px-4 pt-6 pb-4 flex justify-between items-center">
            <ResponsiveModalTitle className="text-[18px] font-bold leading-[24px]">
              {t('order_type_page.select_collection_point_modal.title')}
            </ResponsiveModalTitle>
            {handleClose && <ResponsiveModalClose asChild>
                <button onClick={handleClose} className="text-[24px] flex items-center justify-center border border-transparent hover:border-border rounded-[8px] bg-background hover:bg-slate-100 w-[36px] h-[36px]" aria-label={t('order_type_page.select_collection_point_modal.cancel')}>
                  ×
                </button>
              </ResponsiveModalClose>}
          </div>
          <div className="bg-background rounded-[8px] p-4 gap-2">
            {Object.entries(groupedCollectionPoints).map(([type_0, collectionPoints_0], groupIndex) => <div key={type_0} className="mb-4">
                <h2 className="text-[16px] leading-[24px] font-bold mb-2">{serviceTypes[type_0]}</h2>
                <div className="flex flex-col gap-2">
                  {collectionPoints_0.map((collectionPoint_0, index) => <button key={collectionPoint_0.id} className="flex items-center border-slate-300 hover:border-slate-900 border rounded-[8px] bg-background hover:bg-slate-100 p-4 text-left h-[60px] hover:ring-1 hover:ring-black focus:ring-1 focus:ring-black focus:bg-slate-100" onClick={() => handleSelectCollectionPoint(collectionPoint_0.id)} ref={groupIndex === 0 && index === 0 ? buttonFocusRef : undefined}>
                      <div>
                        <p className="text-[16px] leading-[24px] font-bold">{collectionPoint_0.name}</p>
                      </div>
                    </button>)}
                </div>
              </div>)}
          </div>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>;
};
export default SelectCollectionPointModal;